/**
*TRS_PC_01
 * */

import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
/**
 * TRS_PC_02
 * */
class TransSelectStore extends EventEmitter {
    PageLoadData = ""
    pageloadres = ""
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleOrderStatusStore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.TransactionReport_GoButtonClick: {
                this.PageLoadData = action.action.response;
                this.emit('TRGo');
                break;
            }

            case "ORDERSTS_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ORDERSTS_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ORDERSTS_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
            case "PageLoadResponse": {
                this.pageloadres = action.action.response;
                this.emit('pageloadres');
                break;
            }
            case SDIConstants.methodNames.TransactionReport_ExportToExcel: {
                this.Excel = action.action.response;
                ;
                this.emit('Export');
                break;
            }

        }
    }
}
const objTransSelectStore = new TransSelectStore;
// Dispatcher code
Dispatcher.register(objTransSelectStore.handleOrderStatusStore.bind(objTransSelectStore));
export default objTransSelectStore;